import { RequestState } from '@fullstory/redux-util';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { AppState } from '..';
import { defaultState } from './accessControl';

export const useRequestState = <T>(getRequestState: (s: AppState) => RequestState<T>) => {
  const { loading, error, lastRequested, data } = useSelector(
    (s: AppState) => getRequestState(s) ?? defaultState,
  );

  const result = useMemo(
    () => ({
      isLoading: loading,
      isReady: !loading && !error && lastRequested > -1,
      hasError: error,
      data,
    }),
    [data, error, lastRequested, loading],
  );

  return result;
};
